import React from "react";
import {
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
} from "material-ui";
import CloseIcon from "material-ui-icons/Close";
import AccountCircle from "material-ui-icons/AccountCircle";
import AccountBalanceWallet from "material-ui-icons/AccountBalanceWallet";
import Euro from "material-ui-icons/EuroSymbol";
import AccountBalance from "material-ui-icons/AccountBalance";
import Inbox from "material-ui-icons/Inbox";
import ExitToAppIcon from "material-ui-icons/ExitToApp";
import CreditCard from "material-ui-icons/CreditCard";
import DescriptionIcon from "material-ui-icons/Description";
import Info from "material-ui-icons/InfoOutline";
import { Link, withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";

interface MenuDrawerProps {
    open: boolean;
    drawerToggle: (status: boolean) => void;
    feedbackToggle: (status: boolean) => void;
    logout: () => void;
    userName: string;
}

interface OwnProps extends RouteComponentProps<{}> {}
type Props = MenuDrawerProps & OwnProps;

const MenuDrawer: React.SFC<Props> = (props) => {
    return (
        <Drawer
            open={props.open}
            onClose={() => props.drawerToggle(false)}
            role="navigation"
            aria-label={"Päävalikko"}
        >
            <div
                style={{ height: "100%", display: "flex" }}
                onClick={() => {
                    props.drawerToggle(false);
                }}
                onKeyDown={(event) => {
                    if (event.key === "Escape") {
                        props.drawerToggle(false);
                    }
                }}
            >
                <div className="drawer-list" style={{ flexGrow: 20 }}>
                    <div>
                        <List
                            className="drawer-list-main"
                            style={{ paddingBottom: 0 }}
                        >
                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    button
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.drawerToggle(false);
                                        }
                                    }}
                                    tabIndex={0}
                                >
                                    <ListItemText
                                        style={{ marginLeft: "40px" }}
                                        primary={"Sulje valikko"}
                                    />
                                    <ListItemIcon
                                        style={{
                                            color: "#004170",
                                            marginRight: 0,
                                        }}
                                    >
                                        <CloseIcon />
                                    </ListItemIcon>
                                </ListItem>
                            </ListItem>
                            {/* Profile */}

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/profile" />
                                    )}
                                    button
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/profile");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                    tabIndex={0}
                                >
                                    <ListItemIcon>
                                        <AccountCircle />
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: "hypoblue" }}
                                        primary={props.userName}
                                    />
                                </ListItem>
                            </ListItem>
                        </List>
                        <Divider />
                        <List
                            className="drawer-list-main"
                            style={{ paddingTop: 0, paddingBottom: 0 }}
                        >
                            {/* Account related */}

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/account" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/account");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <AccountBalanceWallet />
                                    </ListItemIcon>
                                    <ListItemText primary="Tilit" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link
                                            {...p}
                                            to="/account/new/deposit"
                                        />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push(
                                                "/account/new/deposit"
                                            );
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <Euro />
                                    </ListItemIcon>
                                    <ListItemText primary="Talletusohje" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link
                                            {...p}
                                            to="/account/request/withdrawal"
                                        />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push(
                                                "/account/request/withdrawal"
                                            );
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <Euro />
                                    </ListItemIcon>
                                    <ListItemText primary="Nostopyyntö" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    component={"a"}
                                    href={
                                        process.env
                                            .REACT_APP_ACCOUNT_APPLICATION_URL
                                    }
                                    target="_system"
                                    button
                                    tabIndex={0}
                                >
                                    <ListItemIcon>
                                        <AccountBalanceWallet />
                                    </ListItemIcon>
                                    <ListItemText primary="Tilihakemus" />
                                </ListItem>
                            </ListItem>
                        </List>
                        <Divider inset />
                        <List
                            className="drawer-list-main"
                            style={{ paddingTop: 0, paddingBottom: 0 }}
                        >
                            {/* Loan related */}

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/loan" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/loan");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <AccountBalance />
                                    </ListItemIcon>
                                    <ListItemText primary="Lainat" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/loan/new/edit" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push(
                                                "/loan/new/edit"
                                            );
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <AccountBalance />
                                    </ListItemIcon>
                                    <ListItemText primary="Muutospyyntö" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    component={"a"}
                                    href={
                                        process.env
                                            .REACT_APP_LOAN_APPLICATION_URL
                                    }
                                    target="_system"
                                    disableRipple
                                    button
                                    tabIndex={0}
                                >
                                    <ListItemIcon>
                                        <Inbox />
                                    </ListItemIcon>
                                    <ListItemText primary="Lainahakemukset" />
                                </ListItem>
                            </ListItem>
                        </List>
                        <Divider inset />
                        <List
                            className="drawer-list-main"
                            style={{ paddingTop: 0, paddingBottom: 0 }}
                        >
                            {/* Apartments and cards */}
                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/creditcards" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/creditcards");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <CreditCard />
                                    </ListItemIcon>
                                    <ListItemText primary="Kortit" />
                                </ListItem>
                            </ListItem>
                        </List>

                        <Divider inset />

                        <List
                            className="drawer-list-secondary"
                            style={{ paddingTop: 0 }}
                        >
                            <ListItem
                                className="sideNavItem"
                                disableRipple
                                component={(p) => (
                                    <Link {...p} to="/documentations" />
                                )}
                                button
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        props.history.push("/documentations");
                                        props.drawerToggle(false);
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <DescriptionIcon />
                                </ListItemIcon>
                                <ListItemText primary="Asiakirjat" />
                            </ListItem>
                        </List>
                        <Divider inset />
                    </div>

                    <div>
                        <List
                            className="drawer-list-secondary"
                            style={{ paddingTop: 0 }}
                        >
                            {/* Info and logout */}

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/accessibility" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push(
                                                "/accessibility"
                                            );
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <Info />
                                    </ListItemIcon>
                                    <ListItemText primary="Saavutettavuusseloste" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/about" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/about");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <Info />
                                    </ListItemIcon>
                                    <ListItemText primary="Tietoa palvelusta" />
                                </ListItem>
                            </ListItem>

                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    component={(p) => (
                                        <Link {...p} to="/terms" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/terms");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <Info />
                                    </ListItemIcon>
                                    <ListItemText primary="Käyttöehdot" />
                                </ListItem>
                            </ListItem>

                            
                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    onClick={() => props.feedbackToggle(true)}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.drawerToggle(false);
                                        }
                                    }}
                                    button
                                    tabIndex={0}
                                >
                                    <ListItemIcon>
                                        <Info />
                                    </ListItemIcon>
                                    <ListItemText primary="Anna palautetta" />
                                </ListItem>
                            </ListItem>


                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    onClick={() => props.logout()}
                                    component={(p) => (
                                        <Link {...p} to="/login" />
                                    )}
                                    button
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.history.push("/login");
                                            props.drawerToggle(false);
                                        }
                                    }}
                                >
                                    <ListItemIcon>
                                        <ExitToAppIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Kirjaudu ulos" />
                                </ListItem>
                            </ListItem>
                            <ListItem style={{ padding: 0 }}>
                                <ListItem
                                    className="sideNavItem"
                                    disableRipple
                                    button
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            props.drawerToggle(false);
                                        }
                                    }}
                                    tabIndex={0}
                                >
                                    <ListItemText
                                        style={{ marginLeft: "40px" }}
                                        primary={"Sulje valikko"}
                                    />
                                    <ListItemIcon
                                        style={{
                                            color: "#004170",
                                            marginRight: 0,
                                        }}
                                    >
                                        <CloseIcon />
                                    </ListItemIcon>
                                </ListItem>
                            </ListItem>
                        </List>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default withRouter(MenuDrawer);



// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.tsx